import { defineBool } from '@spotify-internal/remote-config-properties';

// In order to upload a new property to remote config, you can add
// a new property here and then run `yarn publish-props`
// https://backstage.spotify.net/docs/remote-configuration-js-sdk/with-typescript/

// check out RemoteConfig.tsx to see all the associated rollouts with these properties.

export const internalAdmin = defineBool({
  name: 'internal-admin',
  description: 'Rollout group to specify all internal admin users for Spotify for Publishing',
  default: false,
});

export const inProgressFeatures = defineBool({
  name: 'in-progress-features',
  description: 'Rollout group to specify users who have access to incomplete features.',
  default: false,
});

export const publisherInviteSongwriter = defineBool({
  name: 'publisher-invite-songwriter',
  description: 'Rollout group to test the publisher invite songwriter flow.',
  default: false,
});

export const localization = defineBool({
  name: 'localization',
  description: 'Rollout group to specify users who can use the language picker in S4P.',
  default: false,
});

export const useTopNCountryStreams = defineBool({
  name: 'use-top-n-country-streams',
  description:
    'Rollout group to enable the usage of Top N Country Streams strategy to get total count of global streams of a work and writer.',
  default: false,
});
